module.exports = __webpack_public_path__ + "static/media/_MIC2474.image.6f70d1c6.png";